/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import Chart from "react-apexcharts";
import {COLORES} from "../ContantesColorGraficas";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";

const Linea_Limpia = ({ancho, labels = [], series = [], marginTop = 0, height = 'auto', esMoneda}) => {
    const options = {
        chart: {
            id: "area-bar",
            sparkline: {
                enabled: false,
            },
            toolbar: {
                show: false
            }

        },
        labels: labels,
        stroke: {
            width: 2,
            curve: 'smooth',
        },
        colors: COLORES,
        dataLabels: {
            show: true,
            enabledOnSeries: true,
            // Formato para los números que aparecen sobre la gráfica
            formatter: function (val) {
                return esMoneda ? formatoMoneda(val) : val;
            }
        },
        xaxis: {
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },

        },
        yaxis: {
            opposite: true,
            // Formato para los números del eje Y lateral
            labels: {
                formatter: function (val) {
                    return esMoneda ? formatoMoneda(val) : val;
                }
            }
        },
        legend: {
            show: false
        },
        markers: {
            size: 3
        },
        tooltip: {
            // Formato para el cuadro flotante al pasar el cursor
            y: {
                formatter: function (val) {
                    return esMoneda ? formatoMoneda(val) : val;
                }
            }
        },

    }


    return (
        <Chart
            options={options}
            series={series}
            type="line"
            width={ancho}
            height={height}
            style={{marginTop: 0, marginBottom: -20}}
        />
    )

}
export default Linea_Limpia